import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const FormMandatoryLabel = ({ className, ...rest }: JSX.IntrinsicElements["div"]) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("f-label-color", className)} {...rest}>
      {t("checkoutPage.mandatory")}
    </div>
  );
};
